import { ConditionValue } from 'app/components/filters/types';

export const trimValue = (conditionValue: ConditionValue) => {
  return typeof conditionValue === 'string' ? conditionValue.trim() : conditionValue;
};
